/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const LOAD_CARD_BRAND = 'MFE/CHECKOUT/LOAD/CREDIT_CARD_BRAND';
export const FIND_CARD_BRAND = 'MFE/CHECKOUT/FIND/CREDIT_CARD_BRAND';
